import { useNavigate } from "react-router-dom";
import Layout from "../shared/Layout";
import PageHeader from "../shared/PageHeader";
import "../../css/conversations.css";
import "../../css/student-card.css";
import ConversationsDashboardStats from "./ConversationsDashboardStats";
import BotInfoPanel from "./BotInfoPanel";
import TelegramUsageChart from "../dashboard/TelegramUsageChart";
import ConversationsPeopleWidget from "./ConversationsPeopleWidget";
import TelegramUsersWidget from "./TelegramUsersWidget";
import ConversationTemplatesSection from "./ConversationTemplatesSection";
import ConversationCreateModal from "./ConversationCreateModal";
import IconAdd from "../../components/icons/IconAdd";
import usePersistedState from "../../hooks/usePersistedState";
import { useState } from "react";

export default function ConversationMainView() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = usePersistedState("conversations-menu-tab", "templates");
    const [createOpen, setCreateOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const onCreated = () => {
        setCreateOpen(false);
        setRefreshKey(prev => prev + 1);
    };

    return (
        <Layout>
            <PageHeader name="Бот">
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div className="groups-add-btn" onClick={() => setCreateOpen(true)} title="Створити розмову">
                        <IconAdd />
                    </div>
                    <div className="groups-add-btn-ai" onClick={() => navigate("/conversations-ai-generator")} title="Згенерувати тест за допомогою AI">
                        <IconAdd />
                        AI
                    </div>
                </div>
            </PageHeader>
            <ConversationCreateModal isOpen={createOpen} onClose={() => setCreateOpen(false)} onCreated={onCreated} />
            <main className="main-block">
                <div className="main-content txt-c conv-dashboard-page">
                    <div className="student-card-tabs">
                        <div className={"student-card-tab" + (activeTab === "templates" ? " active" : "")} onClick={() => setActiveTab("templates")}>
                            Шаблони розмов
                        </div>
                        <div className={"student-card-tab" + (activeTab === "usage" ? " active" : "")} onClick={() => setActiveTab("usage")}>
                            Бот використання
                        </div>
                    </div>

                    {activeTab === "templates" ? (
                        <div>
                            <ConversationTemplatesSection key={refreshKey} />
                        </div>
                    ) : ""}

                    {activeTab === "usage" ? (
                        <div>
                            <ConversationsDashboardStats />

                            <div className="conv-dashboard-columns">
                                <div>
                                    <BotInfoPanel />
                                    <ConversationsPeopleWidget />
                                </div>
                                <div>
                                    <div className="conv-dashboard-section">
                                        <h4 className="conv-dashboard-section-title">Активність</h4>
                                        <TelegramUsageChart />
                                    </div>

                                    <TelegramUsersWidget />
                                </div>
                            </div>
                        </div>
                    ) : ""}
                </div>
            </main>
        </Layout>
    );
}
